import { BANNER_TYPES } from '../../types/index.js';

const BANNER_TYPES_WITH_PLACEHOLDERS = [BANNER_TYPES.TGBM_7, BANNER_TYPES.SIDE, BANNER_TYPES.TOP];
const DEFAULT_HAS_PLACEHOLDER = {
    [BANNER_TYPES.TGBM_7]: true,
    [BANNER_TYPES.SIDE]: true,
    [BANNER_TYPES.TOP]: false,
};

export { BANNER_TYPES_WITH_PLACEHOLDERS, DEFAULT_HAS_PLACEHOLDER };
//# sourceMappingURL=banner.js.map
